import _ from 'underscore';

import { MapperHelper } from '../../../ts/mappers/MapperHelper';
import { ProjectMapper } from '../../../ts/mappers/ProjectMapper';
import { UserMapper } from '../../../ts/mappers/UserMapper';
import { IUserInfo } from '../../../ts/models/IUserInfo';
import { INamedItemInfo } from '../../../ts/models/resourceInfoParts';
import { IPublishedConnectionUsageInfo } from '../../../ts/ServerApi/types/IUsageInfo';
import { IPublishedConnection, IPublishedConnectionDetail } from '../../serverApi/types/IPublishedConnection';
import { IPublishedConnectionDetailInfo, IPublishedConnectionInfo } from '../IPublishedConnectionInfo';

export module PublishedConnectionMapper {
  const M = MapperHelper;

  export function map(
    serverApiMetrics: IPublishedConnection[],
    users: _.Dictionary<IUserInfo>,
    projects: _.Dictionary<INamedItemInfo>,
    favoritePublishedConnections: _.Dictionary<any> = {}
  ): IPublishedConnectionInfo[] {
    return serverApiMetrics.map((m: IPublishedConnection) => {
      return mapOne(m, users[m.ownerId], projects[m.projectId], !!favoritePublishedConnections[m.id]);
    });
  }

  // TODO - achristian - 2020-02-19 - TFSID: 1059566 - Fix mocking
  export function mapOne(
    publishedConnection: IPublishedConnection,
    owner?: IUserInfo,
    project?: INamedItemInfo,
    favorite?: boolean
  ): IPublishedConnectionInfo {
    return {
      createdAt: M.toDate(publishedConnection.createdAt),
      updatedAt: M.toDate(publishedConnection.updatedAt),
      description: publishedConnection.description,
      id: publishedConnection.id,
      luid: publishedConnection.luid,
      name: publishedConnection.name,
      owner: UserMapper.mapOne(owner),
      favorite: favorite,
      contentType: 'virtualConnection',
      tags: M.sortTags(publishedConnection.tags),
      project: project,
      dataQualityIndicators:  publishedConnection.dataQualityIndicators || [],
      hasExtracts: publishedConnection.hasExtract,
      lastRefreshedAt: publishedConnection.hasExtract ? M.toDate(publishedConnection.extractsRefreshedAt) : undefined,
      usageInfo: <IPublishedConnectionUsageInfo>{favoritesTotal: 0},
      usageInfoMaxValues: <IPublishedConnectionUsageInfo>{},
    };
  }

  // TODO - achristian - 2020-02-19 - TFSID: 1059566 - Fix mocking
  export function mapDetail(p: IPublishedConnectionDetail): IPublishedConnectionDetailInfo {
    return {
      createdAt: M.toDate(p.createdAt),
      updatedAt: M.toDate(p.updatedAt),
      description: p.description,
      id: p.id,
      luid: p.luid,
      name: p.name,
      owner: UserMapper.mapOne(p.owner),
      favorite: p.favorite,
      contentType: 'virtualConnection',
      tags: M.sortTags(p.tags),
      project: ProjectMapper.mapName(p.project),
      tables: p.tables,
      dataQualityIndicators:  p.dataQualityIndicators || [],
      hasExtracts: p.hasExtract,
      lastRefreshedAt: p.hasExtract ? M.toDate(p.extractsRefreshedAt) : undefined,

    };
  }

  // TODO - achristian - 2020-02-19 - TFSID: 1059566 - Fix mocking
  export function mapFromCRASS(p: any): IPublishedConnectionInfo {
    return {
      createdAt: M.toDate(p.createdTime) || M.toDateFromTimeOffsetObject(p.createdTime),
      updatedAt: M.toDate(p.modifiedTime) || M.toDateFromTimeOffsetObject(p.modifiedTime),
      description: p.description,
      id: p.id + '',
      luid: p.luid,
      name: p.title,
      favorite: false,
      contentType: 'virtualConnection',
      tags: M.sortTags(p.tags),
      project: {
        id: p.projectId ?? p.parentProjectId,
        name: p.containerName
      },
      owner: UserMapper.mapOneOwnerFromCRASS(p),
      dataQualityIndicators:  p.dataQualityIndicators || [],
      hasExtracts: p.hasExtract,
      lastRefreshedAt: p.hasExtract ? M.toDate(p.extractsRefreshedAt) : undefined,
      usageInfo: <IPublishedConnectionUsageInfo>{favoritesTotal: 0},
      usageInfoMaxValues: <IPublishedConnectionUsageInfo>{}
    };
  }
}
